const t = {
  name: "Unlock",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 13V17H11V13H13Z" fill="currentColor"/>
<path d="M7 6C7 3.24 9.24 1 12 1C13.63 1 15.09 1.79 16 3L14.56 4.44C14.03 3.58 13.08 3 12 3C10.35 3 9 4.35 9 6V8H17C18.6523 8 20 9.34772 20 11V19C20 20.6523 18.6523 22 17 22H7C5.34772 22 4 20.6523 4 19V11C4 9.34772 5.34772 8 7 8V6ZM7 10C6.45228 10 6 10.4523 6 11V19C6 19.5477 6.45228 20 7 20H17C17.5477 20 18 19.5477 18 19V11C18 10.4523 17.5477 10 17 10H7Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Unlock
};
